import { Component } from '@angular/core';

@Component({
  selector: 'app-meter-management',
  templateUrl: './meter-management.component.html',
  styleUrl: './meter-management.component.scss',
  standalone: false
})
export class MeterManagementComponent {

}
